import React from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Mail, MessageCircle, Copy, Smartphone } from "lucide-react";

export function InviteDialog({ invite, bizName, onClose }) {
  if (!invite) return null;
  const link = `${window.location.origin}/login`;
  const msg = `Hi ${invite.name}, you've been added to ${bizName} on RESTRO-VENDS.\nSign in: ${link}\nMobile: ${invite.mobile}\nPassword: ${invite.password}\nPlease change your password after your first sign-in.`;
  const phone = invite.mobile.replace(/[^\d]/g, "");
  const copy = () => navigator.clipboard.writeText(msg).then(() => toast.success("Invite copied"), () => toast.error("Couldn't copy"));
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="invite-dialog">
        <DialogHeader><DialogTitle>Send {invite.name} their login</DialogTitle></DialogHeader>
        <p className={`flex items-center gap-2 rounded-xl px-3 py-2 text-sm ${invite.emailSent ? "bg-green-50 text-green-700" : "bg-stone-50 text-stone-600"}`} data-testid="invite-email-status">
          <Mail className="h-4 w-4" /> {invite.emailSent ? `Login details emailed to ${invite.email}` : invite.email ? "We couldn't email the details — share them below." : "No email given — share the details below."}
        </p>
        <pre className="whitespace-pre-wrap rounded-xl border border-[#E5E0D8] bg-[#FAF8F5] p-3 text-xs text-stone-700" data-testid="invite-message">{msg}</pre>
        <div className="grid grid-cols-3 gap-2">
          <Button asChild className="bg-[#25D366] hover:bg-[#1ebe5b]" data-testid="invite-whatsapp-btn"><a href={`https://wa.me/${phone}?text=${encodeURIComponent(msg)}`} target="_blank" rel="noreferrer"><MessageCircle className="mr-1 h-4 w-4" /> WhatsApp</a></Button>
          <Button asChild variant="outline" data-testid="invite-sms-btn"><a href={`sms:${invite.mobile}?&body=${encodeURIComponent(msg)}`}><Smartphone className="mr-1 h-4 w-4" /> SMS</a></Button>
          <Button variant="outline" onClick={copy} data-testid="invite-copy-btn"><Copy className="mr-1 h-4 w-4" /> Copy</Button>
        </div>
        <Button variant="ghost" onClick={onClose} data-testid="invite-done-btn">Done</Button>
      </DialogContent>
    </Dialog>
  );
}
